// src/components/common/ErrorPopup.js
import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Button, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ErrorPopup = ({ open, title = "Erro", error, onClose }) => (
	<Dialog
		open={open}
		onClose={onClose}
		PaperProps={{
			style: {
				borderRadius: 12,
				border: "2px solid #f44336", // Red border to indicate error
			},
		}}
	>
		<DialogTitle
			sx={{
				m: 0,
				p: 2,
				backgroundColor: "#f44336",
				color: "#fff",
				fontWeight: "bold",
			}}
		>
			{title}
			<IconButton
				aria-label="close"
				onClick={onClose}
				sx={{
					position: "absolute",
					right: 8,
					top: 8,
					color: "#fff",
				}}
			>
				<CloseIcon />
			</IconButton>
		</DialogTitle>
		<DialogContent dividers>
			<Typography sx={{ padding: "20px" }} variant="body1">
				{error}
			</Typography>
		</DialogContent>
	</Dialog>
);

export default ErrorPopup;
